import {
  Card,
  CardContent,
  CardDescription,
  CardTitle,
} from "src/components/ui/card";
import { cn } from "src/lib/utils";

export function TutorialVideoCard({
  src,
  title,
  description,
  className,
  contentClassName,
  videoClassName,
}) {
  return (
    <Card className={cn("h-fit w-full", className)}>
      <CardContent
        className={cn("flex flex-row flex-wrap gap-4", contentClassName)}
      >
        <div
          className={cn(
            "relative h-[15rem] w-full min-w-[15rem] overflow-hidden rounded-md border",
            videoClassName
          )}
        >
          <div className="bg-secondary absolute size-full animate-pulse" />
          <iframe
            title={title}
            src={src}
            allowFullScreen
            className="absolute size-full"
            style={{ border: "none" }}
          />
        </div>
        <div className="flex min-w-1/3 flex-col gap-2">
          <CardTitle>{title}</CardTitle>
          <CardDescription>{description}</CardDescription>
        </div>
      </CardContent>
    </Card>
  );
}
